// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--S__gH","heroleft":"hero-module--heroleft--1n57M","herocenter":"hero-module--herocenter--3sSfI"};